import api from './api';

// Task Type Defaults API Service
export const taskTypeDefaultsService = {
  // Get all available task types that can be configured
  getAvailableTypes: () => api.get('/scheduling/task-type-defaults/available-types'),
  
  // Get the effective default for a specific task type (respects hierarchy)
  getEffectiveDefault: (taskType) => api.get(`/scheduling/task-type-defaults/effective/${taskType}`),
  
  // Get all task type defaults organized by hierarchy level
  getTaskTypeDefaults: (taskType = null) => {
    const params = taskType ? { task_type: taskType } : {};
    return api.get('/scheduling/task-type-defaults/', { params });
  },
  
  // Create a new task type default
  createTaskTypeDefault: (defaultData) => api.post('/scheduling/task-type-defaults/', defaultData),
  
  // Update an existing task type default
  updateTaskTypeDefault: (defaultId, updateData) => api.put(`/scheduling/task-type-defaults/${defaultId}`, updateData),
  
  // Delete a task type default
  deleteTaskTypeDefault: (defaultId) => api.delete(`/scheduling/task-type-defaults/${defaultId}`),
  
  // Bulk update user's personal defaults
  bulkUpdateUserDefaults: (defaults) => api.post('/scheduling/task-type-defaults/bulk-update', defaults),
};

export default taskTypeDefaultsService;
